export enum GlobalEmailSettingTab {
  GENERAL_SETTINGS = 'generalSettings',
  AUTOMATED_EMAILS = 'automatedEmails',
  VARIABLES = 'variables',
}
